import { ProductRecommendationsFiltersEnum } from "./components/product-recommender-filters.component";
import { IProductRecommendation } from "./product-recommender.model";
import store from "../../../configs/store.config";
import i18next from "i18next";

export interface IDropdownOptionsInterface {
  key: string;
  label: string;
}

/**
 *
 * @param productRecommendations
 * @param status
 * Product Recommendations filter by status
 */
export const filterProductRecommendationsByStatus = (
  productRecommendations: IProductRecommendation[],
): IProductRecommendation[] => {
  return productRecommendations;
};

/**
 *
 * @param productRecommendations
 * @param searchString
 * @param selectedLang
 * Product Recommendations filter by search
 */
export const filterProductRecommendationsBySearch = (
  productRecommendations: IProductRecommendation[],
  searchString: string,
  selectedLang: string,
) => {
  if (!!searchString) {
    return productRecommendations.filter(pr =>
      pr.name === null || pr.description === null
        ? ""
        : pr.name[selectedLang].toLowerCase().includes(searchString.toLowerCase()) ||
          pr.description[selectedLang].toLowerCase().includes(searchString.toLowerCase()),
    );
  }
  return productRecommendations;
};

/**
 * Filter an array of Product Recommendations using a search string
 */
export const filterProductRecommendations = (
  productRecommendations: IProductRecommendation[],
  filters: Map<string, string[]>,
  selectedLang: string,
): IProductRecommendation[] => {
  let newProductRecommendations: IProductRecommendation[];
  const search = filters.get(ProductRecommendationsFiltersEnum.SEARCH);

  newProductRecommendations = filterProductRecommendationsByStatus(productRecommendations);

  if (search) {
    newProductRecommendations = filterProductRecommendationsBySearch(
      newProductRecommendations,
      search[0],
      selectedLang,
    );
  }

  return newProductRecommendations;
};

/**
 * Get available languages
 */
export const getAvailableLanguagesOptions = () => {
  const productRecommendationsStore = store.getState().productRecommendationsReducer.productRecommendations;

  const languages = Object.keys(
    productRecommendationsStore.productRecommendations.reduce((keys: any, item: any) => {
      const itemKeys = Object.keys(item.name);
      itemKeys.forEach(key => {
        keys[key] = true;
      });
      return keys;
    }, {}),
  ).map(key => {
    return { label: i18next.t(`commons.languages.${key}`), key: key };
  });

  if (languages) {
    return languages.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();

      if (labelA < labelB) {
        return -1;
      }
      if (labelA > labelB) {
        return 1;
      }
      return 0;
    });
  } else {
    return [
      {
        label: i18next.t(`commons.languages.en`),
        key: "en",
      },
    ];
  }
};

/**
 * filterDropdownOptions - Filters the dropdown options by the sent acceptable states
 * @param serviceList {any[]}
 * @param acceptableStates {string[]}
 * @param language {string | undefined}
 *
 * @returns filteredList {dropdownOptionsInterface}
 */
export const filterDropdownOptions = (serviceList: any[], acceptableStates: string[], language?: string) => {
  const filteredList: IDropdownOptionsInterface[] = [];
  if (serviceList && serviceList.length > 0) {
    serviceList.map((service: any) => {
      if (acceptableStates.includes(service.status)) {
        if (service.name instanceof Object && !service.eventId) {
          filteredList.push({
            key: service.name.key,
            label: language && service.name.translations[language],
          });
        } else {
          filteredList.push({
            key: service.eventId ? service.eventId : service.id,
            label: language && service.eventId ? service.name.translations[language] : service.name,
          });
        }
      }
    });
  }
  return filteredList.sort((a, b) => (a.label?.toLowerCase() < b.label?.toLowerCase() ? -1 : 1));
};

/**
 * Get converted languages to SharedDropdownOption
 * @returns
 */
export const getConvertedLanguages = (availableLanguages: String[]) => {
  return (
    availableLanguages &&
    availableLanguages.map(lang => ({
      label: i18next.t(`commons.languages.${lang}`),
      key: lang,
    }))
  );
};
